import axios from 'axios'
import auth from '@/auth/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use((config) => {
  if (auth.isLogged()) {
    config.headers.Authorization = `Bearer ${auth.getTokenLogged()}`
  }
  return config
})

export default {
  async getWorkspace (companyId) {
    const [companyResponse, taxRegimesResponse, billerTypesResponse, currenciesResponse] = await Promise.all([
      api.get('company/getCompany', { params: { company: { id: companyId } } }),
      api.get('main/getTaxRegimes'),
      api.get('main/getBillerTypes'),
      api.get('company/getCurrencies')
    ])

    return {
      company: companyResponse.data.company || { id: 0 },
      record: companyResponse.data.record || { id: 0 },
      invoices: companyResponse.data.invoices || [],
      recentActivity: companyResponse.data.recent_activity || [],
      activityTotal: companyResponse.data.activity_total || 0,
      dataQuality: companyResponse.data.data_quality || {
        percentage: 0,
        completed_checks: 0,
        total_checks: 0,
        missing: [],
        tone: 'critical'
      },
      taxRegimes: taxRegimesResponse.data.taxRegimes || [],
      billerTypes: billerTypesResponse.data.billerTypes || [],
      currencies: currenciesResponse.data.currencies || []
    }
  },

  async getActivityHistory (companyId, page = 1, pageSize = 20) {
    const response = await api.get('company/getActivityHistory', {
      params: {
        company_id: companyId,
        page,
        page_size: pageSize
      }
    })

    return {
      items: response.data.items || [],
      total: response.data.total || 0,
      page: response.data.page || page,
      pageSize: response.data.page_size || pageSize
    }
  },

  async getSecretExposureAudit (companyId, page = 1, pageSize = 20, includePeople = true) {
    const response = await api.get('company/getSecretExposureAudit', {
      params: {
        company_id: companyId,
        page,
        page_size: pageSize,
        include_people: includePeople
      }
    })

    return {
      items: response.data.items || [],
      total: response.data.total || 0,
      page: response.data.page || page,
      pageSize: response.data.page_size || pageSize
    }
  },

  async exportSecretExposureAudit (companyId, includePeople = true) {
    const response = await api.get('company/exportSecretExposureAudit', {
      params: {
        company_id: companyId,
        include_people: includePeople
      },
      responseType: 'blob'
    })

    return response
  }
}
